import { Text, View, StyleSheet } from '@react-pdf/renderer'

// Create styles
const styles = StyleSheet.create({
  heading: {
    fontWeight: 600,
  },
  container: {
    margin: '32px 24px 0',
    gap: 8,
    fontSize: 8,
    fontWeight: 500,
  },
  section: {
    flexDirection: 'row',
    gap: 20,
    borderBottom: '0.5px solid #E7F1F9',
    padding: 8
  },
  half: {
    width: '100%',
    gap: 4
  }
});

const Damage = ({damagedParts}) => <View style={styles.container}>
  <View style={styles.section}>
    <Text style={[styles.heading, styles.half]}>Повреждения / Зақымдану</Text>
    <Text style={[styles.heading, styles.half]}>Виды повреждений / Зақымдану түрлері</Text>
  </View>

  {damagedParts.ru.map(({name, cause}, i) => <View key={name} style={styles.section}>
    <View style={styles.half} break='avoid'>
      <Text>{name}</Text>
      <Text>{damagedParts.kz[i].name}</Text>
    </View>
    <View style={styles.half}>
      <Text>{cause}</Text>
      <Text>{damagedParts.kz[i].cause}</Text>
    </View>
  </View>)}
</View>

export default Damage
